//@flow
import * as React from "react";
import styled from "react-emotion";
import { inject, observer } from "mobx-react";
import styles from "./styles";

const Reveal = styled.div`
  z-index: 2;
  position: fixed;
  background-color: ${props => props.color};
  top: 0;
  left: 0;
  right: 0;
  height: 100vh;
  opacity: ${props => props.opacity || 1};
  transition: all 500ms ease-in;
  transform: translateY(-100%) translateX(0) skewY(0) skewX(0);
  ${props => styles[props.background]};
`;

const Background = props => {
  return <Reveal color="#D1F9F0" background={props.background} />;
};

export default inject(({ store }) => ({
  background: store.appStore.backgrounds.primary,
  updateBackground: store.appStore.updateBackground
}))(observer(Background));



// WEBPACK FOOTER //
// ./src/components/Background/index.js